import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import {
  CardComponent,
  NoDataVisual,
  OverviewCard,
  OverviewCardWithIcon,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import Loader from '../../_components/molecules/Loader';
import episodesOfCareMessages from '../../core-utils/messages/episodesOfCareMessages';
import { useNavigate } from 'react-router-dom';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import { valueWithText } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/OverviewCard';
import DiseasePrevalenceTable from '../../_components/organisms/DiseasePrevalenceTable';
import {
  CostValues,
  MemberValues,
  TotalCost,
  formatCostValues,
  formatMemberValues,
} from '../../core-utils/helper-utils/summaryReportHelper';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  EpisodesValues,
  formatEocCostValues,
  formatEocDetails,
  formatEpisodeValue,
} from '../../core-utils/helper-utils/episodesOfCareHelper';
import { Pagination } from '@mui/material';
import { observer } from 'mobx-react';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { formatTotalCost } from '../../core-utils/helper-utils/summaryReportHelper';
import { numFormatterWithSuffix } from '../../core-utils/helper-utils/helper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { getLast12MonthsRange } from '../CareQualityPage';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModal';
import summaryPageConstants from '../../core-utils/messages/summaryPageConstants';

export interface SummaryPageProps {}

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
    width: '1182px',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  duration: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    height: '27px',
    background: patientAccessTheme.palette.status.white,
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '4px',
    color: patientAccessTheme.palette.text.highemphasis,
    padding: '4px',
  },
  legendsGrid: {
    display: 'flex',
    marginTop: '10px',
  },
  circularLoader: {
    display: 'flex',
    height: '450px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  legendAndPaginationGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '12px',
  },

  legendItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '0px 24px 6px 0px',
  },
});

const EpisodesOfCarePage: React.FC<SummaryPageProps> = observer(({}) => {
  const { classes } = useStyles();
  const messages = episodesOfCareMessages;
  const cohortMessages = summaryPageConstants.SUMMARY_PAGE;
  const navigate = useNavigate();
  const episodeOfCareStore = useStores().episodeOfCareStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const summaryCardsStore = useStores().summaryCardsStore;

  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  const serieNames = [
    {
      name: 'Pre Operative',
      color: patientAccessTheme.palette.warning[500],
    },
    {
      name: 'Surgery Cost',
      color: '#919ED0',
    },
    {
      name: 'Post Operative',
      color: patientAccessTheme.palette.status.success,
    },
  ];

  const [loader] = useState<any>(<Loader />);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const payload = useAPIPayload();
  const [loading, setLoading] = useState<boolean>(false);
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const [episodesValues, setEpisodesValues] = useState<EpisodesValues>({
    episodeCount: '0',
    claimsCount: '0',
    opportunityCost: '$0.00',
  });
  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });
  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [eocTableData, setEocTableData] = useState<any>([]);
  const [totalCostValues, setTotalCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });
  const [totalMemberValues, setTotalMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [episodesOfCareLoader, setEpisodesOfCareLoader] = useState<boolean>(
    false,
  );
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(
    Math.ceil(episodeOfCareStore?.episodeDropDownList?.length / 5),
  );
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [openCohortDetailsModal, setOpenCohortDetailsModal] = useState(false);

  //Functions
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.pageTitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  const handleEpisodeCategory = (episodeCategory: string) => {
    episodeOfCareStore.setSelectedEpisode(episodeCategory);
    navigate(`/episodes-of-care-selected`);
  };

  //API calls
  const getEpisodesOFCareTable = async () => {
    setEpisodesOfCareLoader(true);
    await axios
      .post(
        properties.aiqBaseUrl + properties.episodesOfCare + properties.eocTable,
        {
          max_claim_date:
            employerGroupStore.employerGroupResponseData.max_claim_date,
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
          pageNumber: pageNumber - 1,
        },
      )
      .then((response) => {
        setEocTableData(formatEocDetails(response?.data?.data?.episodes));
        setEpisodesOfCareLoader(false);
      })
      .catch((ex) => {
        setEpisodesOfCareLoader(false);
        return ex;
      });
  };

  const handleCohortDetailsClose = () => {
    setOpenCohortDetailsModal(false);
  };

  const getOverviewCardData = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.episodesOfCare +
          properties.eocOverview,
        {
          max_claim_date:
            employerGroupStore.employerGroupResponseData.max_claim_date,
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
        },
      )
      .then((response) => {
        const data = response?.data?.data[0];
        const isDataEmpty = data?.episode_list.length ? false : true;
        setIsDataEmpty(isDataEmpty);
        const costValues: CostValues = {
          medical: data?.medical_cost,
          rx: data?.rx_cost,
          total: data?.medical_cost + data?.rx_cost,
        };
        setCostValues(costValues);
        const episodesValues = formatEpisodeValue(
          data?.total_claims,
          data?.episode_type_count,
          data?.opportunity_cost,
        );
        const memberValues = {
          members: data?.member_count,
          employees: data?.employee_count,
          dependents: data?.dependent_count,
        };
        setMemberValues(memberValues);
        setEpisodesValues(episodesValues);
        episodeOfCareStore.setEpisodeDropDownList(data?.episode_list);
      })
      .catch((ex) => {
        return ex;
      });
  };

  const getTotalSummaryValues = async () => {
    await axios
      .post(properties.aiqBaseUrl + properties.summaryBaseUrl, {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      })
      .then((res) => {
        if (res?.status === 200) {
          setTotalMemberValues(formatMemberValues(res?.data?.data));
          setTotalCost(formatTotalCost(res?.data?.data));
          setTotalCostValues(formatCostValues(res?.data?.data));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getAllCharts = async () => {
    try {
      setLoading(true);
      await Promise.all([getOverviewCardData(), getTotalSummaryValues()]);
    } catch (error: any) {
      handleOpenSnackBar(error, 'error', 3000);
    } finally {
      setLoading(false);
    }
  };

  //UseEffects
  useEffect(() => {
    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
  }, [employerGroupStore?.selectedDuration]);

  useEffect(() => {
    if (!employerGroupStore.employerGroupResponseData.eg_nid[0]) {
      return;
    }
    getAllCharts();
  }, [employerGroupStore.employerGroupResponseData.eg_nid]);

  useEffect(() => {
    if (!employerGroupStore.employerGroupResponseData.eg_nid[0]) {
      return;
    }
    getEpisodesOFCareTable();
  }, [pageNumber, employerGroupStore.employerGroupResponseData.eg_nid]);

  useEffect(() => {
    setTotalPages(
      Math.ceil(episodeOfCareStore?.episodeDropDownList?.length / 10),
    );
    setPageNumber(1);
  }, [episodeOfCareStore?.episodeDropDownList]);

  //Components
  const SummaryCards = () => {
    return (
      <Grid container>
        {!isDataEmpty && (
          <>
            <Grid style={{ display: 'flex', marginBottom: '29px' }}>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCard
                  title={messages.SUMMARY_CARDS.EPISODES}
                  value={valueWithText(episodesValues.episodeCount, 'Episodes')}
                  // showClickHere={true}
                  rootStyles={{
                    width: '176px',
                    fontWeight: 600,
                    fontSize: ' 24px',
                  }}
                />
              </Grid>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCardTooltipContent
                  type={'member'}
                  cohortMemberValues={memberValues}
                  totalMemberValues={totalMemberValues}
                  overviewCard={
                    <OverviewCard
                      title={messages.SUMMARY_CARDS.MEMBERS}
                      value={getCohortValue(
                        memberValues.members,
                        totalMemberValues.members,
                      )}
                      rootStyles={{
                        width: '176px',
                        fontWeight: 600,
                        fontSize: ' 24px',
                      }}
                    />
                  }
                />
              </Grid>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCard
                  title={messages.SUMMARY_CARDS.CLAIMS}
                  value={episodesValues.claimsCount.toString()}
                  // showClickHere={true}
                  rootStyles={{
                    width: '176px',
                    fontWeight: 600,
                    fontSize: ' 24px',
                  }}
                />
              </Grid>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCardTooltipContent
                  type={'cost'}
                  cohortCostValues={formatEocCostValues(
                    costValues?.medical,
                    costValues?.rx,
                  )}
                  totalCostValues={totalCostValues}
                  overviewCard={
                    <OverviewCard
                      title={'Episodes Cost'}
                      value={getCohortValue(
                        '$' + numFormatterWithSuffix(Number(costValues.total)),
                        totalCost?.totalCost,
                      )}
                      rootStyles={{
                        width: '216px',
                      }}
                      labelsMinWidth="72px"
                    />
                  }
                />
              </Grid>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCardWithIcon
                  title={messages.SUMMARY_CARDS.OPPORTUNITY_COST}
                  values={[[episodesValues.opportunityCost, '']]}
                  // percentValues={valueWithPercentage('0%', false)}
                  rootStyles={{
                    height: '100px',
                  }}
                  titleTypographyStyles={{
                    fontSize: '14px',
                    lineHeight: '24px',
                    color: `${patientAccessTheme.palette.text.highemphasis}`,
                    fontWeight: 600,
                    margin: '0px 4px 0px 0px',
                  }}
                  toolTipContent={messages.SUMMARY_CARDS.OPPORTUNITY_COST_HOVER}
                  toolTipStyles={{
                    width: '222px',
                  }}
                />
              </Grid>
            </Grid>
            <Grid style={{ display: 'flex', marginBottom: '28px' }}>
              <CardComponent
                title={messages.EPISODES_TABLE.TITLE}
                subTitle={messages.EPISODES_TABLE.SUB_TITLE}
                body={
                  episodesOfCareLoader ? (
                    <Box className={classes.circularLoader}>
                      <CircularLoader />
                    </Box>
                  ) : (
                    <Grid style={{ marginTop: '14px' }}>
                      <DiseasePrevalenceTable
                        data={eocTableData}
                        handleEpisodeCategory={handleEpisodeCategory}
                        handleDiseaseCategory={function () {}}
                        isEpisodesOfCare={true}
                        highestPrevalenceRate={0}
                      />
                      <Grid className={classes.legendAndPaginationGrid}>
                        <Grid className={classes.legendsGrid}>
                          {serieNames?.map((item) => {
                            return (
                              <Grid className={classes.legendItem}>
                                <div
                                  style={{
                                    backgroundColor: item?.color,
                                    height: '8px',
                                    width: '8px',
                                    borderRadius: '2px',
                                  }}
                                ></div>
                                <Typography
                                  fontSize="12px"
                                  lineHeight="24px"
                                  fontType="regular"
                                  fontFamily="Inter"
                                  textColor={
                                    patientAccessTheme.palette.text
                                      .mediumemphasis
                                  }
                                  margin="0px 0px 0px 7px"
                                >
                                  {item?.name}
                                </Typography>
                              </Grid>
                            );
                          })}
                        </Grid>
                        <Pagination
                          count={totalPages}
                          page={pageNumber}
                          onChange={handlePageChange}
                          color="primary"
                          size="small"
                        />
                      </Grid>
                    </Grid>
                  )
                }
                width="1178px"
                height="fit-content"
              />
            </Grid>
          </>
        )}
        {isDataEmpty && (
          <NoDataVisual
            height="400px"
            width="1182px"
            content={messages.NO_DATA_CONTENT}
          />
        )}
      </Grid>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <Grid container className={classes.root}>
          <PageTitleAndSubTitle
            title={messages.pageTitle.title}
            subTitle={messages.pageTitle.subTitle}
            showDownloadButton={true}
            // downloadButtonAction={() => setOpenReportsModal(true)}
            downloadButtonAction={() => {
              downloadPdf(
                'episodesOfCareReport',
                {
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  member_unique_id_list: [],
                  claim_id_list: [],
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                  ...payload,
                },
                handleOpenSnackBar,
                'open',
              );
              handleOpenSnackBar(
                snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                'info',
                6000,
              );
            }}
            chip={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px 2px 0px"
                >
                  for
                </Typography>
                <Grid className={classes.duration}>
                  {getLast12MonthsRange(
                    employerGroupStore.employerGroupResponseData.max_claim_date,
                  )}
                </Grid>
              </Grid>
            }
            showQueryDataButton={checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )}
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                setOpenCohortDetailsModal(true);
              } else {
                // setOpenFeatureAccessModal(true);
              }
            }}
          />
          <CohortFilterBar />
          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
            margin="18px 0px 36px 0px"
          />
          {selectedTabIndex === 0 && <SummaryCards />}
          {selectedTabIndex === 1 && (
            <RecommendationsTab
              recommendationLoading={recommendationLoading}
              isInternalPage={false}
            />
          )}
        </Grid>
      )}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={startDate}
        endDate={endDate}
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={openCohortDetailsModal}
        isPage={true}
        setOpenCohortDetailsModal={setOpenCohortDetailsModal}
        handleClose={handleCohortDetailsClose}
        title={cohortMessages.COHORT_DETAILS.TITLE}
        subTitle={cohortMessages.COHORT_DETAILS.SUBTITLE}
        totalResults={summaryCardsStore.totalEnrolled?.totalCount}
        // startDate={
        //   aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        // }
        // endDate={
        //   aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        // }
        employerGroup={employerGroupStore?.employerGroupResponseData?.eg_nid}
        type="data"
      />
    </>
  );
});

export default EpisodesOfCarePage;
